import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-float-label " }
const _hoisted_2 = {
  for: "type",
  class: "kn-material-input-label"
}
const _hoisted_3 = {
  key: 0,
  class: "p-field p-col-3"
}
const _hoisted_4 = { class: "p-float-label " }
const _hoisted_5 = {
  for: "type",
  class: "kn-material-input-label"
}
const _hoisted_6 = { class: "p-float-label " }
const _hoisted_7 = {
  for: "columnType",
  class: "kn-material-input-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")
  const _component_Button = _resolveComponent("Button")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_KnCalculatedField = _resolveComponent("KnCalculatedField")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_DataTable, {
      value: _ctx.businessModel.calculatedBusinessColumns,
      class: "p-datatable-sm kn-table p-ml-2",
      responsiveLayout: "stack",
      breakpoint: "960px"
    }, {
      empty: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          field: "name",
          header: _ctx.$t('common.name'),
          sortable: true
        }, null, 8, ["header"]),
        _createVNode(_component_Column, {
          style: _ctx.descriptor.style.iconColumnStyle,
          class: "p-text-right"
        }, {
          header: _withCtx(() => [
            _createVNode(_component_Button, {
              label: _ctx.$t('common.add'),
              class: "p-button-link p-text-right",
              onClick: _ctx.addCalcField
            }, null, 8, ["label", "onClick"])
          ]),
          body: _withCtx((slotProps) => [
            _createVNode(_component_Button, {
              icon: "far fa-edit",
              class: "p-button-link",
              onClick: ($event: any) => (_ctx.editCalcField(slotProps.data))
            }, null, 8, ["onClick"]),
            _createVNode(_component_Button, {
              icon: "pi pi-trash",
              class: "p-button-link",
              onClick: ($event: any) => (_ctx.deleteCalcField(slotProps.data))
            }, null, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["style"])
      ]),
      _: 1
    }, 8, ["value"]),
    (_ctx.calcFieldDialogVisible)
      ? (_openBlock(), _createBlock(_component_KnCalculatedField, {
          key: 0,
          template: _ctx.selectedCalcField,
          "onUpdate:template": _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectedCalcField = $event)),
          visibility: _ctx.calcFieldDialogVisible,
          "onUpdate:visibility": _cache[5] || (_cache[5] = ($event: any) => (_ctx.calcFieldDialogVisible = $event)),
          fields: _ctx.calcFieldColumns,
          descriptor: _ctx.calcFieldDescriptor,
          propCalcFieldFunctions: _ctx.calcFieldFunctions,
          source: 'QBE',
          readOnly: false,
          valid: true,
          onSave: _ctx.onCalcFieldSave,
          onCancel: _cache[6] || (_cache[6] = ($event: any) => (_ctx.calcFieldDialogVisible = false))
        }, {
          additionalInputs: _withCtx(() => [
            _createVNode("div", {
              class: ["p-field", [_ctx.selectedCalcField.type === 'DATE' ? 'p-col-3' : 'p-col-4']]
            }, [
              _createVNode("span", _hoisted_1, [
                _createVNode(_component_Dropdown, {
                  id: "type",
                  class: "kn-material-input",
                  modelValue: _ctx.selectedCalcField.type,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedCalcField.type = $event)),
                  options: _ctx.descriptor.types,
                  optionLabel: "label",
                  optionValue: "name"
                }, null, 8, ["modelValue", "options"]),
                _createVNode("label", _hoisted_2, _toDisplayString(_ctx.$t('components.knCalculatedField.type')), 1)
              ])
            ], 2),
            (_ctx.selectedCalcField.type === 'DATE')
              ? (_openBlock(), _createBlock("div", _hoisted_3, [
                  _createVNode("span", _hoisted_4, [
                    _createVNode(_component_Dropdown, {
                      id: "type",
                      class: "kn-material-input",
                      modelValue: _ctx.selectedCalcField.format,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedCalcField.format = $event)),
                      options: _ctx.descriptor.admissibleDateFormats
                    }, {
                      value: _withCtx(() => [
                        _createVNode("span", null, _toDisplayString(_ctx.selectedCalcField.format ? _ctx.moment().format(_ctx.selectedCalcField.format) : ''), 1)
                      ]),
                      option: _withCtx((slotProps) => [
                        _createVNode("span", null, _toDisplayString(_ctx.moment().format(slotProps.option)), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "options"]),
                    _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('managers.datasetManagement.ckanDateFormat')), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", {
              class: ["p-field", [_ctx.selectedCalcField.type === 'DATE' ? 'p-col-3' : 'p-col-4']]
            }, [
              _createVNode("span", _hoisted_6, [
                _createVNode(_component_Dropdown, {
                  id: "columnType",
                  class: "kn-material-input",
                  modelValue: _ctx.selectedCalcField.nature,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedCalcField.nature = $event)),
                  options: _ctx.descriptor.columnTypes,
                  optionLabel: "label",
                  optionValue: "name"
                }, null, 8, ["modelValue", "options"]),
                _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('managers.functionsCatalog.columnType')), 1)
              ])
            ], 2)
          ]),
          _: 1
        }, 8, ["template", "visibility", "fields", "descriptor", "propCalcFieldFunctions", "onSave"]))
      : _createCommentVNode("", true)
  ], 64))
}